import React from 'react';
import { Pagination } from '@material-ui/lab';
import './styles.scss';

const pagination = props => {
    const { count, defaultPage, onChange } = props;

    return <Pagination className="pagination" count={count} defaultPage={defaultPage} onChange={onChange} />;
};

export default pagination;
